import { Component, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Application } from 'app/shared/services/app/application/application.model';
import { AppBuilderService } from 'app/forms/services/app-builder/app-builder.service';
import { ContentValidators } from 'app/validators/content/content-validators';

@Component({
  selector: 'tog-mobile-login-form',
  templateUrl: './mobile-login-form.component.html',
  styleUrls: ['./mobile-login-form.component.scss']
})
export class MobileLoginFormComponent implements OnDestroy {
  mobileLoginSettingsForm: FormGroup;
  formChangeSubscription: Subscription;

  @Input() appToEdit: Application;

  constructor(private _fb: FormBuilder,
              private _ab: AppBuilderService) {
    this.mobileLoginSettingsForm = _fb.group({
      enable_login_screen: ['', Validators.required],
      allow_guest: [''],
      allow_user_signup: [''],
      login_company_url: ['', ContentValidators.mustBeUrl]
    });
    this.formChangeSubscription = this.mobileLoginSettingsForm.valueChanges.subscribe((formValue) => {
      this._ab.updateForm(this.mobileLoginSettingsForm, 'mobile');
    });
  }

  setUpAppToEdit() {
    if (this.appToEdit) {
      this.mobileLoginSettingsForm.controls['enable_login_screen'].setValue(this.appToEdit.settings.hasLoginScreen);
      this.mobileLoginSettingsForm.controls['allow_guest'].setValue(this.appToEdit.settings.allowGuest);
      this.mobileLoginSettingsForm.controls['allow_user_signup'].setValue(this.appToEdit.settings.allow_signup);
      this.mobileLoginSettingsForm.controls['login_company_url'].setValue(this.appToEdit.settings.companyLoginUrl);
      this.mobileLoginSettingsForm.markAsPristine();
    }
  }

  ngOnDestroy() {
    if (this.formChangeSubscription) this.formChangeSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /app/src/app/forms/components/mobile-login-form/mobile-login-form.component.ts